{
  "takim": {
    "Baslik": "Takımlar",
    "Liste": "Takım Listesi",
    "Yeni Ekle": "Yeni Takım Ekle",
    "Ara": "Ara",
    "Temizle": "Temizle",
    "Yenile": "Yenile",
    "Duzenle": "Düzenle",
    "Sil": "Sil",
    "Durum": "Durum",
    "Kullanici Ata": "Personel Ataması",
    "Ad": "Takım Adı",
    "Kayit Sil": "Kaydı Sil",
    "Sil Onay": "Bu takımı silmek istediğinize emin misiniz? Takımdaki tüm kullanıcılar da takımdan çıkarılacaktır.",
    "Iptal": "İptal",
    "Kaydet": "Kaydet",
    "Guncelle": "Güncelle",
    "Aktif": "Aktif",
    "Pasif": "Pasif",
    "Ekle": "Ekle",
    "Yonetici": "Yönetici mi?",
    "Tümü": "Tümü",
    "Kapat": "Kapat",
    "Personeller": "Takımdaki Personeller",
    "Personel Secin": "Personel Seçin...",
    "Henuz Personel Yok": "Henüz takımda personel bulunmuyor."
  },
  "takim_hedef": {
    "Baslik": "Takım Hedef Tanımları",
    "Firma-Ürün": "Firma-Ürün",
    "Satış Group": "Satış Group",
    "Tutar": "Tutar",
    "Ekle": "Hedef Ekle",
    "Hedef Ekle": "Yeni Hedef Tanımla",
    "Hedef Güncelle": "Hedef Güncelle",
    "Düzeltme": "Düzeltme",
    "Sil": "Sil",
    "Data Yenile": "Verileri Güncelle",
    "Örn": "Örnek",
    "Kaydet": "Kaydet",
    "Güncelle": "Güncelle",
    "İptal": "İptal",
    "Ürün": "Ürün",
    "Seçiniz": "Seçiniz"
  }
}
